import Page from 'Scripts/classes/Page'
import Form from 'Scripts/components/Form'
import axios from 'axios'
import gsap from 'gsap'
// const sgMail =require('@sendgrid/mail')

export default class extends Page {
  constructor() {
    super('contact', {
      container: '.contact',
      elements: {
        form: '.form__wrapper',
        submit: '#submit',
      },
    })
    this.submission = false
    //Methods
    this.elements.form && this.submitForm()
  }

  submitForm() {
    this.form = new Form({
      form: '.form__wrapper',
      fields: {
        nom: '#nom',
        prenom: '#prenom',
        email: '#email',
        telephone: '#telephone',
        societe: '#societe',
        fonction: '#fonction',
        sujet: '#sujet',
        message: '#message',
      },
      submit: '#submit',
    })

    //Bind Event
    this.elements.form.addEventListener('submitform', () => this.onSubmit(), false)
  }

  async onSubmit() {
    if (this.submission) return
    // console.log('Submit Form')
    this.submission = true
    this.elements.submit.disabled = true
    this.elements.submit.style.opacity = '0.6'
    //  this.elements.submit.textContent = 'Envoi en cours...'
    //
    this.acf = {}
    for (const [key, field] of this.form.formData.entries()) {
      // console.log(key, field)
      this.acf[key] = field
    }
    // axios({
    //   method: 'post',
    //   // url: `${process.env.API}/contact/`,
    //   url: `${process.env.SGTMAPI}/addcontact/`,
    //   data: {
    //     title: `${this.acf['nom']} ${this.acf['prenom']}`,
    //     status: 'publish',
    //     acf: this.acf,
    //   },
    // })
    axios({
      method: 'post',
      url: `${process.env.SGTMAPI}/proxy`, // 🔁 On passe par le proxy
      data: {
        endpoint: 'contact', // 🔸 Le proxy saura vers quel endpoint relayer
        data: {
          title: `${this.acf['nom']} ${this.acf['prenom']}`,
          status: 'publish',
          acf: this.acf,
        },
      },
    })
      .then((response) => {
        // console.log(response)
        //send email
        this.sendMail()
        //
        gsap
          .timeline()
          .to(this.form.container.parentNode, {
            autoAlpha: 0,
            y: 150,
            duration: 1,
            onComplete: () => {
              this.form.container.parentNode.remove()
              window.dispatchEvent(new Event('resize', { cancelable: true }))
            },
          })
          .fromTo(
            '.form__msg',
            {
              y: 150,
            },
            {
              autoAlpha: 1,
              display: 'block',
              y: 0,
              duration: 1,
            }
          )
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  async sendMail() {
    // console.log('Send Mail')
    //J'utilise maintenant une fonction php pour envoyer le mail directement du serveur WP
    // await axios({
    //   method: 'post',
    //   url: `${process.env.API}/sendemail/`,
    //   data: {
    //     form: 'contact',
    //     subject: this.acf['sujet'],
    //     data: this.acf,
    //   },
    // })
    //   .then((response) => {
    //     // console.log(response.data)
    //   })
    //   .catch((error) => {
    //     console.log(error.message)
    //   })
  }

  // sendMail() {
  //   sgMail.setApiKey(process.env.SENDGRID_API_KEY)

  //   const msg = {
  //     to: 'mahdi.bamoulid@gmail.com', // Change to your recipient
  //     from: 'contact@embprojects.com', // Change to your verified sender
  //     subject: 'Sending with SendGrid is Fun',
  //     text: 'and easy to do anywhere, even with Node.js',
  //     html: '<strong>and easy to do anywhere, even with Node.js</strong>',
  //   }
  //   sgMail.send(msg)
  //     .then(() => {
  //       console.log('Email sent')
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //     })
  // }

  /**
   * Animations.
   */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    // console.log('onResize')
    return super.onResize()
  }
}
